<div class="paid-status-wrap">
  {{ (isPaid ? 'FINANCES.EXPENSES.PAYMENT_DONE' : 'FINANCES.EXPENSES.PENDING_PAYMENT') | translate }}
  <yu-badge type="dot" [color]="isPaid ? 'success' : 'error'"></yu-badge>
</div>
